import { useQyGetLevel } from "@factory/query/level.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { Dropdown } from "primereact/dropdown";
import { useState } from "react";

export function useUtilLevel() {
  // DECLARATIONS
  const [selectedLevel, setSelectedLevel] = useState(null);

  // API DEFINITIONS
  const { data: levelResponse } = useQyGetLevel("", 9999, 0);
  const levelData = levelResponse?.data || [];
  const levelOptions = LabelValue.MapArray(
    levelData,
    (item) => item?.name,
    (item) => item.code
  );

  // LOCAL FUNCTIONS

  // LOCAL RENDERS
  const levelDropdown = (
    <Dropdown
      value={selectedLevel}
      onChange={(e) => setSelectedLevel(e.value)}
      options={levelOptions}
      placeholder="Select a level"
      className="w-full md:w-14rem"
    />
  );

  return { levelDropdown, selectedLevel, setSelectedLevel };
}
